type Itinerary = {
  campaignConfig: {
    primeDayConfig?: {
      isPrimeDayFare?: boolean;
    };
  };
};

const predicate =
  (hasPrimeDayFilterApplied: boolean) => (itinerary: Itinerary) => {
    return (
      !hasPrimeDayFilterApplied ||
      itinerary.campaignConfig?.primeDayConfig?.isPrimeDayFare
    );
  };

export default predicate;
